import React, { useState } from "react";
import SectionTitle from "../shared/SectionTitle";
import SectionCard from "../shared/SectionCard";
import PriorityCard from "./PriorityCard";

/**
 * Renders a deduplicated, severity-sorted list of pastoral priorities.
 * priorities: Array<{ key, message, level }>
 * actionMap:  Record<key, () => void>  — optional per-key click handlers
 * max:        max visible before "Ver más" expander (default 3)
 */
export default function PriorityStack({
  priorities  = [],
  actionMap   = {},
  compact     = false,
  max         = 3,
  title       = "Prioridades",
  showTitle   = true,
}) {
  const [expanded, setExpanded] = useState(false);

  if (priorities.length === 0) return null;

  const visible = expanded ? priorities : priorities.slice(0, max);
  const hasMore = priorities.length > max && !expanded;

  return (
    <>
      {showTitle && (
        <SectionTitle
          title={title}
          action={
            hasMore ? (
              <button
                onClick={() => setExpanded(true)}
                className="text-[11px] font-semibold text-violet-500 dark:text-violet-400"
              >
                Ver más
              </button>
            ) : undefined
          }
        />
      )}
      <SectionCard className="divide-y divide-slate-100 dark:divide-slate-700/60">
        {visible.map((p) => (
          <PriorityCard
            key={p.key}
            priority={p}
            compact={compact}
            onClick={actionMap[p.key]}
          />
        ))}
      </SectionCard>
    </>
  );
}
